import React from "react";

// Fixed to the panel bottom: the price, every problem (role="alert"), and the two buttons. The sub-line is not a
// live region: it carries a countdown that ticks every second; expiry is announced by the notice.
export default function PanelFooter({ model, onAction }) {
  const { notice } = model;
  return (
    <div className="md-panel__foot">
      {notice ? (
        <div role="alert" className={`md-notice md-notice--${notice.tone}`}>
          <strong className="md-notice__title">{notice.title}</strong>
          {notice.text ? <span>{notice.text}</span> : null}
          {notice.steps ? (
            <ol className="md-notice__steps">
              {notice.steps.map((step) => (
                <li key={step}>{step}</li>
              ))}
            </ol>
          ) : null}
          {notice.jump ? (
            <button type="button" className="md-link" onClick={() => onAction(notice.jump.action)}>
              {notice.jump.label}
            </button>
          ) : null}
        </div>
      ) : null}
      <div className="md-panel__bar">
        <div className="md-panel__price">
          <span className="md-medium">{model.left}</span>
          {model.sub ? <span className={`md-mono md-small md-tone-${model.subTone}`}>{model.sub}</span> : null}
        </div>
        {model.secondary ? (
          <button type="button" className="md-btn md-btn--lg" onClick={() => onAction(model.secondary.action)}>
            {model.secondary.label}
          </button>
        ) : null}
        <button
          type="button"
          className="md-btn md-btn--primary md-btn--lg"
          disabled={model.primary.disabled}
          onClick={() => onAction(model.primary.action)}
        >
          {model.primary.label}
        </button>
      </div>
    </div>
  );
}
